import { render, staticRenderFns } from "./WmsMasterForm.vue?vue&type=template&id=2b4a3637"
import script from "./WmsMasterForm.vue?vue&type=script&lang=js"
export * from "./WmsMasterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports